import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getGeneralApi } from "../api/general";
import { Toast } from "primereact/toast";

export const Dptos = () => {
    const [dptos, setDptos] = useState({});
    const [loading1, setLoading1] = useState(true);
    const toast = useRef();

    useEffect(() => {
        getGeneralApi("listaDptos")
            .then((respuesta) => {
                if (respuesta?.data?.success) {
                    setDptos(respuesta.data.items);
                    setLoading1(false);
                } else {
                    toast.current.show({ severity: "error", summary: "Error", detail: "Error en lista de dptos." });
                }
            })
            .catch((response) => {
                toast?.current?.show({ severity: "error", summary: "Error", detail: "Error en la petición al servidor" });
            });
    }, []);

    const bodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]}
            </>
        );
    };

    const dptoBodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                <i className="pi pi-users"></i>
                <span style={{ marginLeft: ".5em", verticalAlign: "middle" }} className="image-text">
                    {data[props.field]}
                </span>
            </>
        );
    };

    return (
        <>
            <Toast ref={toast} position="top-right"></Toast>
            <div className="p-grid table-demo">
                <div className="p-col-12">
                    <div className="card">
                        <h5>Listado de Departamentos</h5>
                        <p>Departamentos en la aplicación de EuroseGur PGI</p>
                        <DataTable value={dptos} className="p-datatable-customers p-datatable-striped p-datatable-sm" dataKey="id" rowHover emptyMessage="No se han encontrado gestores" loading={loading1}>
                            <Column headerStyle={{ width: "6em" }} body={(data, props) => props.rowIndex + 1}></Column>
                            <Column field="id" header="Id" headerStyle={{ width: "6em" }} sortable body={bodyTemplate}></Column>
                            <Column field="nombre" headerStyle={{ width: "20em" }} header="Nombre" sortable body={dptoBodyTemplate}></Column>
                            <Column field="descripcion" header="Descripción" sortable body={bodyTemplate}></Column>
                        </DataTable>
                    </div>
                </div>
            </div>
        </>
    );
};
